export const data =
{
    scene: '01_SoitettuOvikelloa',
    kysymysteksti: 'Pian ovelle ilmestyy tulee hymyilevä, iäkäs mieshenkilö. Myös puuskuttava ohjaajasi ehtii paikalle. Hymyilet ja tervehdit ovelle saapuvaa miestä:',
    maxp: 2,

    optiot: [
        {
            id: 1,
            teksti: 'A Päivää, teidän ovi oli tainnut unohtua auki, Olen (oma nimi), lähihoitajaopiskelija kotihoidosta ja ohjaajani (ohjaajan nimi). Onko teidän nimi Pentti Elo?',
            valinta: 'A_TervehdysOk',
            ohjaajan_palaute: 'Hienoa, esittelit molemmat, teitittelit ja vuorovaikutus oli reipasta ja varmistit asiakkaan henkilöllisyydenkin!',
            koontiteksti: 'Esittelit itsesi ja ohjaajan ammatillisesti ja reippaasti. Lähdit varmentamaan asiakkaan henkilöllisyyttä. Valintaasi liittyi ammattitaitovaatimus <i>Toimii vuorovaikutuksessa asiakkaan kanssa</i>, josta toteutuivat kriteerit <i>Toimii ammatillisesti vaihtuvissa vuorovaikutustilanteissa.</i> sekä <i>huomioi oman käyttäytymisensä vaikutukset vuorovaikutustilanteissa</i>. Valintasi ilmentää osaamistasoa <b>K5</b>',
            pisteet: 2,
            arviointitiedosto: 'scene_01_AA_tervehdysOk',
            harjoiteltava: [],

        },
        {

            id: 2,
            teksti: 'B Hyvää päivää, olen (oma nimi) kotihoidosta, tulimme tarkistamaan teidän lääkityksen ja voinnin.',
            valinta: 'B_EiVarmistutaAsiakkaasta',
            ohjaajan_palaute: 'Esittelit itsesi ja tervehdit reippaasti ja esitit asiankin hyvin, mutta olisiko minutkin voitu esitellä? Entä varmistuitko että ovella seisova henkilö todella on asiakas eikä esim. naapurin rouva?',
            koontiteksti: 'Esittelit itsesi reippaasti, mutta et ohjaajaasi. Et lähtenyt varmentamaan asiakkaan henkilöllisyyttä. Valintaasi liittyivät seuraavat ammattitaitovaatimukset <ul><li><i>Toimii vuorovaikutuksessa asiakkaan kanssa</i>, josta toteutui H3-tason kriteeri <i>kohtaa asiakkaan, omaiset ja lähiverkoston välittävästi</i>, mutta jäi toteutumatta T1-tason kriteeri <i>Toimii ammatillisesti vuorovaikutustilanteissa osana työryhmää.</i></li> <li><i>työskentelee lähihoitajan työtä ohjaavien säädösten ja ohjeiden mukaan</i>, josta jäi toteutumatta H3-tason kriteeri <i>noudattaa sosiaali- ja terveysalan säädöksiä, säännöksiä, määräyksiä ja eettisiä periaatteita muuttuvissa tilanteissa</i>  </li></ul>. Valintasi ilmetää osaamistasoa T2',
            pisteet: 1,
            arviointitiedosto: 'scene_01_AB_EiVarmistutaAsiakkaasta',
            harjoiteltava: [],

        }
        ,
        {
            id: 3,
            teksti: 'C Päivää, oletko sinä Pentti Elo?',
            valinta: 'C_Sinuteltu',
            ohjaajan_palaute: 'Tervehdit reippaasti, mutta kuuluu asiaan esitellä itsensä ja asiansa ensimmäiseksi. Nyt asiakas hyvin todennäköisesti menee hämilleen.. Lisäksi lähtökohtaisesti teititellään.',
            koontiteksti: 'Tervehdit asiakasta reippaasti, mutta et ottanut huomioon, että tämä on varmasti yllättynyt, että vieraita ihmisiä on eteisessä yllättäen ja se voi olla pelottava tilanne. Tilanteen hahmottaminen tökki nyt aika pahasti. Lähtökohtaisesti asiakasta myös teititellään. Valintaasi liittyivät seuraavat ammattitaitovaatimukset <ul><li><i>Toimii vuorovaikutuksessa asiakkaan kanssa</i>, josta jäivät toteutumatta kriteerit <i>Toimii ammatillisesti vuorovaikutustilanteissa osana työryhmää</i> sekä <i>Huomioi oman käyttäytymisensä vaikutukset vuorovaikutustilanteissa</i></li> <li><i>Työskentelee lähihoitajan työtä ohjaavien säädösten ja ohjeiden mukaan</i>, josta jäi toteutumatta kriteeri <i>Noudattaa sosiaali- ja terveysalan säädöksiä, säännöksiä, määräyksiä ja eettisiä periaatteita toistuvissa tilanteissa </i></ul>Näillä perusteilla toimintasi oli tässä kohti <b>hylätyn</b> tasoista',
            pisteet: 0,
            arviointitiedosto: 'scene_01_AC_sinutellaan',
            harjoiteltava: []

        }

    ]
};



